import { Component, OnInit } from '@angular/core';
import { Globals } from 'src/app/wings-mobile/shared/globals/globals';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'user-cdsid',
    templateUrl: './cdsid.component.html',
    styleUrls: ['./cdsid.component.scss'],
    imports: [RouterLink]
})
export class CdsidComponent implements OnInit {

	user_name: String;
	constructor(public globals: Globals) {
		this.globals = globals;
	}

	ngOnInit() {
		this.user_name = this.globals.tokenData.uid.toUpperCase();
	}

}

